module.exports = __webpack_public_path__ + "img/haihengerr.f4cd2e93.png";